import*as r from"react";function l(l){var n;return parseInt(r.version,10)>=19?(null==l||null==(n=l.props)?void 0:n.ref)||null:(null==l?void 0:l.ref)||null}export{l as g};
